import React from 'react';
import { Box, Button, ITheme, SvgIcon, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ReactComponent as fileIcon } from '../../assets/file.svg'
import { ReportItem } from '../../models/Common';
import { LeoDocumentsPath, LeoDocumentsPathExample } from '../../resources/api-constants';

export interface IReportsListItemProps {
    report: ReportItem;
}

const ReportsListItem: React.FC<IReportsListItemProps> = ({ report }) => {
    const theme = useTheme() as ITheme;
    const { i18n } = useTranslation();

    const onDownload = () => {
        window.open(LeoDocumentsPath + '/' + LeoDocumentsPathExample);
    }

    return <Box display="flex" flexDirection={"column"} alignItems={"flex-start"} justifyContent={"space-between"} width={"240px"} borderRadius={"8px"} bgcolor={theme.palette.common.white} sx={{ boxShadow: "0px 2px 16px 0px #0000000F" }} gap={"37px"} padding={"27px 23px"}>
        <Box display="flex" flexDirection={"column"} gap={"12px"}>
            <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"700"} color={theme.palette.primary.dark}>{report.name}</Typography>
            <Typography fontSize={"15px"} lineHeight={"18.29px"} fontWeight={"400"}>{report.date.toLocaleDateString(i18n.language)}</Typography>
        </Box>
        <SvgIcon component={fileIcon} inheritViewBox style={{ width: "100%", height: "75px", color: theme.palette.leo.primary.blue[100] }} />
        <Button variant='outlined' sx={{ width: "100%", textTransform: "none", fontWeight:"600", padding: "10px 0" }} onClick={onDownload}>Download pdf</Button>
    </Box>;
}

export default ReportsListItem;